var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import BaseSelect from '@libs/@core/components/select/BaseSelect';
/**
 *
 * @param name Tên của field trong form
 *
 * @param label Label của field
 *
 * @param labelProps Props của label
 *
 * @param callBackFn Hàm callback custom khi thay đổi giá trị
 *
 * @returns
 */
var BaseSelectForm = function (props) {
    var id = props.id, name = props.name, label = props.label, labelProps = props.labelProps, callBackFn = props.callBackFn, required = props.required, multiple = props.multiple, rest = __rest(props, ["id", "name", "label", "labelProps", "callBackFn", "required", "multiple"]);
    var generateId = useId();
    var methods = useFormContext();
    var idSelect = id !== null && id !== void 0 ? id : generateId;
    return (_jsxs(FormControl, { fullWidth: true, children: [label && (_jsxs(FormLabel, __assign({ htmlFor: idSelect }, labelProps, { children: [label, " ", _jsx("span", { style: { color: 'red' }, children: required ? '*' : '' })] }))), _jsx(Controller, { name: name, control: methods.control, render: function (_a) {
                    var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
                    function onChangeSelect(value) {
                        onChange(value);
                        callBackFn && callBackFn(value, methods);
                    }
                    return (_jsxs(_Fragment, { children: [_jsx(BaseSelect, __assign({ id: idSelect, "aria-labelledby": idSelect, value: multiple ? (Array.isArray(value) ? value : []) : value || '', onChange: onChangeSelect, sx: error && {
                                    '.MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'red'
                                    }
                                }, multiple: multiple }, rest)), error && error.message && _jsx(FormHelperText, { error: true, children: error.message })] }));
                } })] }));
};
export default BaseSelectForm;
